import React, { useMemo } from 'react';
import { RSK_CHAIN_ID } from '../../../config/chains';
import { getChainById } from '../../../utils/chain';
import { TxIdWithNotification } from '../TxIdWithNotification/TransactionIdWithNotification';
export const TransactionIdRenderer = ({ hash, dataAttribute, chainId = RSK_CHAIN_ID, }) => {
    const chain = useMemo(() => getChainById(chainId), [chainId]);
    return (React.createElement(TxIdWithNotification, { href: `${chain === null || chain === void 0 ? void 0 : chain.blockExplorerUrl}/tx/${hash}`, value: hash, dataAttribute: dataAttribute }));
};
